<script>
export default {
  data() {
    return {
      isPasswordVisible: false,
      isPasswordVisibleOne: false,
      isPasswordVisibleTwo: false,
      isPasswordVisibleThree: false,
      isPasswordVisibleFour: false,
      isPasswordVisibleFive: false,
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    togglePasswordVisibilityOne() {
      this.isPasswordVisibleOne = !this.isPasswordVisibleOne;
    },
    togglePasswordVisibilityTwo() {
      this.isPasswordVisibleTwo = !this.isPasswordVisibleTwo;
    },
    togglePasswordVisibilityThree() {
      this.isPasswordVisibleThree = !this.isPasswordVisibleThree;
    },
    togglePasswordVisibilityFour() {
      this.isPasswordVisibleFour = !this.isPasswordVisibleFour;
    },
    togglePasswordVisibilityFive() {
      this.isPasswordVisibleFive = !this.isPasswordVisibleFive;
    },
    submitForm() {
      this.$router.push("/success");
    },
    submitFormOne() {
      this.$router.push("/customer-settings/security-settings");
    },
    submitFormTwo() {
      this.$router.push("/customer-settings/security-settings");
    },
  },
};
</script>
<template>
  <!-- Change Password -->
  <div class="modal fade custom-modal" id="change-password">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Change Password</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body p-4">
          <form @submit.prevent="submitForm">
            <div class="mb-3">
              <label class="form-label">Current Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">New Password</label>
              <div class="pass-group" id="passwordInput">
                <input
                  :type="isPasswordVisibleOne ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibilityOne"
                  :class="
                    isPasswordVisibleOne
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
              <div class="password-strength" id="passwordStrength">
                <span id="poor"></span>
                <span id="weak"></span>
                <span id="strong"></span>
                <span id="heavy"></span>
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Confirm New Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisibleTwo ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibilityTwo"
                  :class="
                    isPasswordVisibleTwo
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer border-top">
          <div class="acc-submit">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Update Password</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Change Password -->

  <!-- Change Email -->
  <div class="modal fade custom-modal" id="change-email">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Change Email</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body p-4">
          <form @submit.prevent="submitFormOne">
            <div class="wallet-add">
              <div class="mb-3">
                <label class="form-label">Current Email Address</label>
                <input type="email" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label"
                  >New Email Address <span class="text-danger">*</span></label
                >
                <input type="email" class="form-control" />
              </div>
              <div class="mb-3">
                <label class="form-label">Confirm New Password</label>
                <div class="pass-group">
                  <input
                    :type="isPasswordVisibleThree ? 'text' : 'password'"
                    class="form-control pass-input"
                    placeholder="*************"
                  />
                  <span
                    @click="togglePasswordVisibilityThree"
                    :class="
                      isPasswordVisibleThree
                        ? 'toggle-password feather-eye'
                        : 'toggle-password feather-eye-off'
                    "
                  ></span>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer border-top">
          <div class="acc-submit">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Change Email</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Change Email -->

  <!-- Change Phone -->
  <div class="modal fade custom-modal" id="change-phone">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content doctor-profile">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Change Phone Number</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body p-4">
          <form @submit.prevent="submitFormOne">
            <div class="wallet-add">
              <div class="mb-3">
                <label class="form-label">Current Phone Number</label>
                <input
                  class="form-control form-control-lg group_formcontrol"
                  id="phone"
                  name="phone"
                  type="text"
                  placeholder="Enter Phone Number"
                />
              </div>
              <div class="mb-3">
                <label class="form-label"
                  >New Phone Number <span class="text-danger">*</span></label
                >
                <input
                  class="form-control form-control-lg group_formcontrol"
                  id="phone1"
                  name="phone"
                  type="text"
                  placeholder="Enter Phone Number"
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Confirm New Password</label>
                <div class="pass-group">
                  <input
                    :type="isPasswordVisibleFour ? 'text' : 'password'"
                    class="form-control pass-input"
                    placeholder="*************"
                  />
                  <span
                    @click="togglePasswordVisibilityFour"
                    :class="
                      isPasswordVisibleFour
                        ? 'toggle-password feather-eye'
                        : 'toggle-password feather-eye-off'
                    "
                  ></span>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer border-top">
          <div class="acc-submit">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button class="btn btn-dark" type="submit">Change Number</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Change Phone -->

  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitFormTwo">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisibleFive ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibilityFive"
                  :class="
                    isPasswordVisibleFive
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-2"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Cancel Appointment -->
  <!-- Add Wallet -->
  <div
    class="modal fade wallet-modal"
    id="add-wallet"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Add Wallet</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <div class="modal-body">
          <form>
            <div class="mb-3">
              <label for="amount" class="form-label">Amount</label>
              <input type="text" class="form-control" id="amount" />
            </div>
          </form>
          <div class="row">
            <div class="col-md-4">
              <div class="bank-selection">
                <input
                  type="radio"
                  value="attach_link"
                  id="rolelink"
                  name="attachment"
                  checked
                />
                <label for="rolelink">
                  <img src="@/assets/img/icons/paypal.svg" alt="Paypal" />
                  <span class="role-check"><i class="fa-solid fa-circle-check"></i></span>
                </label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="bank-selection">
                <input
                  type="radio"
                  value="attach_link"
                  id="rolelink1"
                  name="attachment"
                />
                <label for="rolelink1">
                  <img src="@/assets/img/icons/stripe.svg" alt="Stripe" />
                  <span class="role-check"><i class="fa-solid fa-circle-check"></i></span>
                </label>
              </div>
            </div>
            <div class="col-md-4">
              <div class="bank-selection">
                <input
                  type="radio"
                  value="attach_link"
                  id="rolelink2"
                  name="attachment"
                />
                <label for="rolelink2">
                  <img src="@/assets/img/icons/bank-transfer.svg" alt="image" />
                  <span class="role-check"><i class="fa-solid fa-circle-check"></i></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-dark">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>
